export enum DeliveryFormatTrackingLabel {
    GiftBox = 'Geschenkbox',
    PdfVoucher = 'PDF-Gutschein',
}
